// extracted by mini-css-extract-plugin
export const root = "CruiseSegmentSummary-module--root--R-gjQ";
export const name = "CruiseSegmentSummary-module--name--1rpVd";
export const dates = "CruiseSegmentSummary-module--dates--2R-_8";
export const mapContainer = "CruiseSegmentSummary-module--map-container--QIh9Y";
export const map = "CruiseSegmentSummary-module--map--2b99J";